const HEALTH_SEGMENT = '/health';
const WELFARE_SEGMENT = '/welfare';
const DASHBOARD_SUFFIX = '/dashboard';

/** Fish speed is not part of welfare or health — never redirect this path. */
const WELFARE_SPEED_SUFFIX = '/speed';

/** Pen URL prefix before `/welfare` or `/health` (e.g. `/c/1/location/2/pen/3`). */
export function getPenBasePathname(pathname: string): string | null {
    const welfareSegmentIndex = pathname.indexOf(WELFARE_SEGMENT);
    if (welfareSegmentIndex !== -1) {
        return pathname.slice(0, welfareSegmentIndex);
    }

    const healthSegmentIndex = pathname.indexOf(HEALTH_SEGMENT);
    if (healthSegmentIndex !== -1) {
        return pathname.slice(0, healthSegmentIndex);
    }

    return null;
}

export function getPenDashboardPath(pathname: string): string | null {
    const penBase = getPenBasePathname(pathname);
    return penBase ? `${penBase}${DASHBOARD_SUFFIX}` : null;
}

export function getPenHealthPath(pathname: string): string | null {
    const penBase = getPenBasePathname(pathname);
    return penBase ? `${penBase}${HEALTH_SEGMENT}` : null;
}

/** Bioscope 1.0 pens hitting /health/* are sent to the legacy welfare dashboard. */
export function getHealthBwRedirectPath(pathname: string): string {
    const healthSegmentIndex = pathname.indexOf(HEALTH_SEGMENT);

    if (healthSegmentIndex === -1) {
        return pathname;
    }

    return `${pathname.slice(0, healthSegmentIndex)}${WELFARE_SEGMENT}`;
}

/**
 * Color bioscopes (2.0 / 3.0): redirect any welfare URL to the health dashboard.
 * Returns null for /welfare/speed and non-welfare paths.
 */
export function getWelfareColorRedirectPath(pathname: string): string | null {
    const welfareSegmentIndex = pathname.indexOf(WELFARE_SEGMENT);

    if (welfareSegmentIndex === -1) {
        return null;
    }

    const suffix = pathname.slice(welfareSegmentIndex + WELFARE_SEGMENT.length);
    if (suffix === WELFARE_SPEED_SUFFIX || suffix.startsWith(`${WELFARE_SPEED_SUFFIX}/`)) {
        return null;
    }

    return `${pathname.slice(0, welfareSegmentIndex)}${HEALTH_SEGMENT}`;
}
